module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new3/main_sp_5cc1e28c82e5c4eb47236025bd5c169d.jpg";